import { render, staticRenderFns } from "./comingSoon.vue?vue&type=template&id=fda0d92e&"
import script from "./comingSoon.vue?vue&type=script&lang=js&"
export * from "./comingSoon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports